import React from "react"
import Title from "../Title"
import Blog from "./Blog"
import { Link } from "gatsby"
import styled from "styled-components"
import useFilter from "../../constants/useFilter"

const SearchButton = [
  "All",
  "JavaScript",
  "React",
  "Gatsby",
  "Graphql",
  "Node",
  "Markdown",
  "Scss",
  "CSS",
  "HTML"
]
const Blogs = ({ blogs, title, showLink }) => {
  const [Result, button, setButton] = useFilter(blogs, "category")
  return (
    <Container>
      <Title title={title} />

      {!showLink && (
        <SubTitle>
          Blogs all about web development best practices and new features. which
          includes Html,Css to React.JS, Redux, Gatsby.JS, and Node.JS and many
          more.
        </SubTitle>
      )}
      {!showLink && (
        <FilterContainer>
          {SearchButton.map(item => (
            <FilterButton
              key={item}
              onClick={() => setButton(item)}
              isSelected={button === item}
            >
              {item}
            </FilterButton>
          ))}
        </FilterContainer>
      )}
      {!showLink && (
        <Description>
          {button === "All" ? (
            <>showing all blogs. Use the filter to list them by categories.</>
          ) : (
            <>
              {" "}
              Showing <span>{Result.length}</span> blogs filtered by{" "}
              <span>{button}</span> .{" "}
            </>
          )}
        </Description>
      )}
      {!showLink && Result.length < 1 ? (
        <Info>There is no blogs currently based on {button}.</Info>
      ) : (
        <div className="section-center blogs-center">
          {Result?.map(blog => (
            <Blog key={blog.id} {...blog} />
          ))}
        </div>
      )}
      {showLink && (
        <Link to="/blog" className="btn center-btn">
          blog
        </Link>
      )}
    </Container>
  )
}
export default Blogs

export const Container = styled.section`
  background: ${({ theme }) => theme.body};
  min-height: calc(100vh + 5rem);
  padding: 5rem 0;
`

export const FilterContainer = styled.section`
  max-width: 50%;
  margin-bottom: 3rem;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 900px) {
    max-width: 90%;
  }
`
export const FilterButton = styled.button`
  color: ${({ theme, isSelected }) =>
    isSelected ? "white" : theme.headerColor};
  padding: 3px 5px;
  margin-right: 0.4rem;
  margin-top: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  outline: none;
  border-radius: 0 0 6px 0;
  border: 1px solid
    ${({ theme, isSelected }) =>
      isSelected ? "var(--clr-primary-5)" : theme.textColor};
  background: ${({ isSelected, theme }) =>
    isSelected ? "var(--clr-primary-5)" : theme.contentBackground};
  transition: all 0.3s ease-in-out;

  &:hover {
    background: var(--clr-primary-5);
    color: ${({ theme }) => theme.tagColor};
  }
  @media (max-width: 900px) {
    margin-top: 0.8rem;
  }
`

export const SubTitle = styled.h4`
  width: 55%;
  margin: 0.5rem auto 1.4rem;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: left;
  letter-spacing: 1.5px;

  @media (max-width: 900px) {
    width: 90%;
    font-size: 0.9rem;
    line-height: 1.3rem;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    margin-right: auto;
    margin-left: auto;
  }
`
export const Info = styled.h4`
  width: 55%;
  margin: 0.5rem auto 1.4rem;
  font-size: 1.3rem;
  line-height: 1.5rem;
  text-align: center;
  letter-spacing: 1.5px;

  @media (max-width: 900px) {
    width: 90%;
    font-size: 0.9rem;
    line-height: 1.3rem;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    margin-right: auto;
    margin-left: auto;
  }
`
export const Description = styled.h6`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5rem auto 2rem;
  font-size: 0.9rem;
  letter-spacing: 1px;
  & span {
    font-size: 1rem;
    padding: 0 3px;
    letter-spacing: 2px;
    color: ${({ theme }) => theme.headerColor};
  }
  @media (max-width: 900px) {
    width: 90%;
  }
`
